import { render, staticRenderFns } from "./SplitOrder.vue?vue&type=template&id=46dd5b47&"
import script from "./SplitOrder.vue?vue&type=script&lang=js&"
export * from "./SplitOrder.vue?vue&type=script&lang=js&"
import style0 from "./SplitOrder.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports